import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/ui-kit/dialog';
import { Button } from '@/ui-kit/button';
import { useTutorialStore } from './useTutorialStore';

export const TutorialWelcomeModal: React.FC = () => {
  const { welcomeOpen, skip, startTutorial, startGuidedSetup } = useTutorialStore();

  if (!welcomeOpen) return null;

  return (
    <Dialog open={welcomeOpen} onOpenChange={(open) => { if (!open) skip(); }}>
      <DialogContent
        className="sm:max-w-md"
        onPointerDownOutside={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>Welcome to the Truss Dashboard</DialogTitle>
          <DialogDescription>
            Get started by tailoring your dashboard to the threats and data you care about, or take a
            quick tour of the main areas. You can skip and explore on your own at any time.
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-2 mt-4">
          <Button onClick={startGuidedSetup}>
            Set up my dashboard
          </Button>
          <Button variant="outline" onClick={startTutorial}>
            Take dashboard tour
          </Button>
          <Button variant="ghost" onClick={skip}>
            Skip for now
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
